const dataTabs = [
  { id: "comprehensive", name: "Vocabulary" },
  { id: "ksep", name: "School Readiness" },
];

export default dataTabs;
